/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Table_Search_ColumnsInputs */

const en_table_search_columns = /** @type {(inputs: Table_Search_ColumnsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search columns...`)
};

const es_table_search_columns = /** @type {(inputs: Table_Search_ColumnsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar columnas...`)
};

/**
* | output |
* | --- |
* | "Search columns..." |
*
* @param {Table_Search_ColumnsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const table_search_columns = /** @type {((inputs?: Table_Search_ColumnsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_Search_ColumnsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_table_search_columns(inputs)
	return es_table_search_columns(inputs)
});